// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AccionaBigUploadButton_wrapper__1nurk"};